import { ApprovedIcon } from '@/assets/icons/info-icons/approved';
import ActionDropdown from '@/components/basicComponents/actionDropdown';
import Button from '@/components/basicComponents/button';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { FieldActionsProps } from '../types';
import { hasLinkedField, shouldShowAcceptButton, shouldShowClearButton, shouldShowOverrideButton, shouldShowRelinkButton } from '../utils/fieldUtils';

export const FieldActions = ({
  field,
  mode,
  onEditField,
  onAcceptAiAnswer,
  onClearField,
  onOverrideAnswer,
  onRelinkField,
  showAcceptButton = true,
  showClearButton = true,
  showEditButton = true,
  isDisabled = false
}: FieldActionsProps) => {
  if (mode !== 'edit' || isDisabled) return null;

  const renderStandardActions = () => {
    const actions = [];

    if (showEditButton && onEditField) {
      actions.push({ name: 'Edit', onClick: () => onEditField(field) });
    }

    if (showClearButton && shouldShowClearButton(field) && onClearField) {
      actions.push({ name: 'Clear', onClick: () => onClearField(field) });
    }

    return (
      <>
        {showAcceptButton && shouldShowAcceptButton(field) && onAcceptAiAnswer && (
          <AcceptAiAnswerButton id="acceptAiAnswerButton" onClick={() => onAcceptAiAnswer(field)}>
            <ApprovedIcon width={23} height={23} fill={themeVar('font.action')} />
          </AcceptAiAnswerButton>
        )}
        {actions.length > 0 && <ActionDropdown options={actions} />}
      </>
    );
  };

  const renderLinkedFieldActions = () => {
    if (shouldShowOverrideButton(field) && onOverrideAnswer) {
      return (
        <LinkedFieldButton id="overrideAnswerButton" onClick={() => onOverrideAnswer(field)} styleType="outline">
          Override Answer
        </LinkedFieldButton>
      );
    }

    if (shouldShowRelinkButton(field) && onRelinkField) {
      return (
        <ButtonsWrapper>
          <LinkedFieldButton id="relinkFieldButton" onClick={() => onRelinkField(field)} styleType="outline">
            Discard Answer and Relink Field
          </LinkedFieldButton>
          {renderStandardActions()}
        </ButtonsWrapper>
      );
    }

    return null;
  };

  if (hasLinkedField(field)) {
    return renderLinkedFieldActions();
  }

  return <ButtonsWrapper>{renderStandardActions()}</ButtonsWrapper>;
};

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 0 10px;
  margin-left: auto;
  align-items: center;
`;

const AcceptAiAnswerButton = styled.div`
  background-color: ${themeVar('layer.base')};
  border: 1px solid ${themeVar('font.action')};
  border-radius: 4px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const LinkedFieldButton = styled(Button)`
  margin-left: auto;
`;
